import { createSlice } from "@reduxjs/toolkit";

const aitsTestSlice = createSlice({
  name: "aitsTests",
  initialState: {
    loading: false,
    error: null,
    tabs: [],
    list: [],
    syllabusLoading: false,
    syllabusData: null,
  },
  reducers: {
    fetchAitsTestListRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchAitsTestListSuccess: (state, action) => {
      state.loading = false;
      state.tabs = action.payload.tabs;
      state.list = action.payload.list;
    },
    fetchAitsTestListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    fetchAitsSyllabusRequest: (state) => {
  state.syllabusLoading = true;
  state.error = null;
},

fetchAitsSyllabusSuccess: (state, action) => {
  state.syllabusLoading = false;
  state.syllabusData = action.payload;
},

fetchAitsSyllabusFailure: (state, action) => {
  state.syllabusLoading = false;
  state.error = action.payload;
},

clearAitsSyllabus: (state) => {
  state.syllabusData = null;
},

  },
});


export const {
  fetchAitsTestListRequest,
  fetchAitsTestListSuccess,
  fetchAitsTestListFailure,
  fetchAitsSyllabusRequest,
  fetchAitsSyllabusSuccess,
  fetchAitsSyllabusFailure,
  clearAitsSyllabus,
} = aitsTestSlice.actions;

export default aitsTestSlice.reducer;


